// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3aZia","label":"LabeledBox_label__2BIsv"};